import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { Button } from '@/shared/Button';
import { Input } from '@/shared/Input';
import React from 'react';

import { openProfileModal } from '@/redux/modal/modal.slice';
import DatePicker from 'react-datepicker';
import { addAuthToken } from '@/redux/user/user.thunks';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { userSelector } from '@/redux/user/user.selectors';
import { ONE, ZERO } from '@/constants/common';

import 'react-datepicker/dist/react-datepicker.css';

const ONE_WEEK_IN_DAYS = 7;
export const AddAuthTokenModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(userSelector);

  const date = new Date();
  date.setDate(date.getDate() + ONE_WEEK_IN_DAYS);
  const [data, setData] = React.useState({
    name: '',
    expirationDate: date,
    userId: user.userData?.id || ZERO,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;
    setData(prevData => ({ ...prevData, [name]: value }));
  };

  const handleExpirationDateChange = (value: Date | null): void => {
    if (value) {
      setData(prevData => ({ ...prevData, expirationDate: value }));
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    await dispatch(addAuthToken(data));
    dispatch(openProfileModal());
  };

  return (
    <div className="w-[400px] border border-t-[#E1E0E6] bg-white p-[24px]">
      <form onSubmit={handleSubmit}>
        <label className="mb-5 block text-sm font-semibold" htmlFor="email">
          Token name
          <Input
            type="text"
            name="name"
            id="name"
            placeholder="Token name here..."
            value={data.name}
            onChange={handleChange}
            className="mt-2.5 text-sm font-medium text-font-400"
          />
        </label>
        <label className="mb-5 text-sm font-semibold" htmlFor="expirationDate">
          Expiration date (max 1 year):
          <DatePicker
            name="expirationDate"
            id="expirationDate"
            dateFormat="yyyy-MM-dd"
            selected={data.expirationDate}
            onChange={value => handleExpirationDateChange(value)}
            minDate={((): Date => {
              const tomorrow = new Date();
              tomorrow.setDate(tomorrow.getDate() + ONE);
              return tomorrow;
            })()}
            maxDate={((): Date => {
              const oneYearFromNow = new Date();
              oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + ONE);
              return oneYearFromNow;
            })()}
            className="mt-2.5 w-full border border-transparent bg-cultured px-2 py-2.5 text-sm font-medium text-font-400 outline-none hover:border-greyscale-600 focus:border-greyscale-600"
          />
        </label>
        <Button type="submit" className="mt-2.5 w-full justify-center text-base font-medium">
          Submit
        </Button>
      </form>
    </div>
  );
};
